import React, { memo, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Checkbox } from '@rsos/base-components';
import {
  gspx,
  GPX_EVENT_TYPES,
  GPX_FEATURES,
  GPX_CAPABILITIES,
  GPX_ROUTES,
} from '@rsos/gainsight';
import {
  togglePureWireless,
  selectPureWirelessVisible,
} from '@rsos/reduxDataStore/src/features/additionalLayers/additionalLayersSlice';
import { RegularCheckboxWrapper } from '../LayerCheckbox.styles';
import useToggleGuard from '../useToggleGuard';

interface PureWirelessLayerControlProps {
  irpVersion?: string;
}

export const PureWirelessLayerControl = memo<PureWirelessLayerControlProps>(
  ({ irpVersion }) => {
    const dispatch = useDispatch();
    const isVisible = useSelector(selectPureWirelessVisible);

    const handleToggle = useCallback(() => {
      const newVisible = !isVisible;
      dispatch(togglePureWireless());

      // Analytics tracking
      const onOffText = newVisible ? 'on' : 'off';
      gspx.trackEvent({
        name: 'map_turn_pure_wireless_layer',
        type: GPX_EVENT_TYPES.INFO,
        feature: GPX_FEATURES.LEGACY,
        capability: GPX_CAPABILITIES.LEGACY,
        route: GPX_ROUTES.MAP,
        additionalKeys: {
          legacy_category: 'Data Map',
          legacy_name: `Turn ${onOffText} Pure Wireless`,
          Category: 'Additional Layer',
          'Launched date': new Date(),
          irpVersion,
          visibility_state: newVisible ? 'show' : 'hide',
        },
      });
    }, [dispatch, isVisible, irpVersion]);

    const guardedToggle = useToggleGuard(handleToggle);

    return (
      <RegularCheckboxWrapper>
        <Checkbox
          label="Indoor floor maps"
          description="911Locate"
          isChecked={isVisible}
          onChange={guardedToggle}
        />
      </RegularCheckboxWrapper>
    );
  },
);

export default PureWirelessLayerControl;
